import React from 'react';
import logo from '../assets/images/Logo.png';
import styles from '../styles/RefundPolicy.module.css';

const ShippingDeliveryPolicy = () => (
  <div className={styles['refund-container']}>
    <div className={styles['refund-header-row']}>
      <div className="aboutus-logo-col">
        <img src={logo} alt="AstroShubh Logo" className={styles['refund-logo']} />
      </div>
      <div className={styles['refund-title-col']}>
        <h1 className={styles['refund-title']}>Shipping & Delivery Policy</h1>
        <p className={styles['refund-company-info']}>
          <span><strong>Website:</strong> www.astroshubh.com</span><br/>
          <span><strong>Operated by:</strong> Tara Infotech (“Company”)</span><br/>
          <span><strong>Brand Name:</strong> AstroShubh</span>
        </p>
      </div>
    </div>
    <div className={styles['refund-content']}>
      <h2 className={styles['refund-main-title']}>Shipping & Delivery Policy – AstroShubh</h2>
      <h3 className={styles['refund-section-title']}>1. INTRODUCTION</h3>
      <p className={styles['refund-section-text']}>
        This Shipping & Delivery Policy (“Policy”) explains how products and services purchased through AstroShubh (Tara Infotech) are delivered. By placing an order with us on https://astroshubh.com, you agree to the terms set forth below.
      </p>
      <h3 className={styles['refund-section-title']}>2. DIGITAL PRODUCTS & SERVICES</h3>
      <ul className={styles['refund-list']}>
        <li>Instant Delivery: E-books, PDFs, reports, and digital remedies are usually delivered instantly via email and/or WhatsApp within 15–60 minutes of payment confirmation.</li>
        <li>Processing Time: Personalized reports or consultations may take 24–72 hours, depending on the complexity of the request.</li>
        <li>Non-Delivery: If you do not receive your digital product within the stated time, please contact us at support@astroshubh.com with your order ID.</li>
      </ul>
      <h3 className={styles['refund-section-title']}>3. PHYSICAL PRODUCTS (IF APPLICABLE)</h3>
      <ul className={styles['refund-list']}>
        <li>Domestic Shipping (India): Orders are typically shipped within 2–5 business days. Delivery timelines vary between 3–7 days depending on the location.</li>
        <li>International Shipping: Delivery outside India may take 15–30 business days. Delays may occur due to customs clearance or courier issues.</li>
        <li>Tracking: A tracking ID will be provided once your order has been dispatched.</li>
        <li>Shipping Charges:
          <ul>
            <li>Within India: Free shipping on most orders (unless specified).</li>
            <li>International: Shipping charges calculated at checkout. Customs duties and local taxes are the responsibility of the customer.</li>
          </ul>
        </li>
      </ul>
      <h3 className={styles['refund-section-title']}>4. DELAYS & LIABILITY</h3>
      <ul className={styles['refund-list']}>
        <li>Delivery times are estimates and may vary due to factors beyond our control (courier delays, strikes, natural disasters, government restrictions, etc.).</li>
        <li>AstroShubh is not liable for delays caused by third-party courier services or customs authorities.</li>
        <li>Customers are advised to provide accurate shipping details. The Company is not responsible for delivery failures due to incorrect addresses or recipient unavailability.</li>
      </ul>
      <h3 className={styles['refund-section-title']}>5. ORDER TRACKING</h3>
      <p className={styles['refund-section-text']}>
        You can track your order using the tracking ID shared by us via email/WhatsApp. For digital orders, tracking is not applicable since they are delivered electronically.
      </p>
      <h3 className={styles['refund-section-title']}>6. FAILED DELIVERIES</h3>
      <ul className={styles['refund-list']}>
        <li>If an order cannot be delivered due to incorrect details, refusal at delivery, or non-collection from courier partners, the customer will bear the reshipping costs (if applicable).</li>
      </ul>
      <h3 className={styles['refund-section-title']}>7. INTERNATIONAL ORDERS</h3>
      <ul className={styles['refund-list']}>
        <li>Customs duties, import taxes, and clearance charges are payable by the customer.</li>
        <li>Refunds (if applicable) for undelivered international orders will be processed only after the item is returned to us, subject to deduction of customs and courier charges.</li>
      </ul>
      <h3 className={styles['refund-section-title']}>8. CONTACT US</h3>
      <p className={styles['refund-section-text']}>
        For queries related to shipping or delivery:<br/>
        <span role="img" aria-label="email">📧</span> support@astroshubh.com<br/>
    
      </p>
    </div>
  </div>
);

export default ShippingDeliveryPolicy;
